export function buildReembolsoFormData(formValues) {
  const {
    cliente,
    responsavelTipo,
    formaPagamento,
    descricao,
    valor,
    dataCompra,
    localCompra,
    autorizadoPor,
    tipoDocumento,
    numeroDocumento,
    ultimosNumerosCartao,
    file,
  } = formValues;

  const formData = new FormData();

  formData.append('cliente', cliente?.value ? JSON.stringify({
    id: cliente.value,
    cpf: cliente.cpf,
    nome: cliente.label,
  }) : '');
  formData.append('responsavelTipo', responsavelTipo);
  formData.append('formaPagamento', formaPagamento);
  formData.append('descricao', descricao);
  formData.append('valor', valor);
  formData.append('dataCompra', dataCompra || '');
  formData.append('localCompra', localCompra || '');
  formData.append('autorizadoPor', autorizadoPor || '');
  formData.append('tipoDocumento', tipoDocumento?.value ?? tipoDocumento ?? '');
  formData.append('numeroDocumento', numeroDocumento || '');
  formData.append(
    'ultimosNumerosCartao',
    formaPagamento === 'reembolso' ? '' : (ultimosNumerosCartao || ''),
  );

  if (file instanceof File) {
    formData.append('file', file);
  }

  return formData;
}

export function validateClienteNicash(formValues, setError) {
  const { responsavelTipo, formaPagamento, cliente } = formValues;

  if (responsavelTipo === 'paciente' && formaPagamento === 'nicash' && !cliente) {
    setError('cliente', { type: 'manual', message: 'Para essa forma de pagamento selecione um Paciente' });
    return false;
  }

  return true;
}
